/**
 * Created by vladislav on 4/2/2024
 */

const SocialDetector = function () {
    if (connector.platform.oneOf(
        connector.DIGITAL,
        connector.DIGITALWEB, 
        connector.RUSTORE,
        connector.COOLMATHGAMES, 
        connector.XIAOMI, 
        connector.YOUTUBE, 
        connector.GAMESNACK,
        connector.ONESTORE,
        connector.G5WINDOWS,
        connector.ADDICTINGGAMES
    )
        || connector.platform.oneOf(connector.IOS, connector.MACOS) && !WebViewFacebook.isAvailable() && !AppleSocial.isAvailable()
        || connector.platform.oneOf(connector.AMAZON) && !WebViewFacebook.isAvailable()
        || connector.platform.oneOf(connector.MICROSOFT) && !MicrosoftFacebook.isAvailable()
        || connector.platform.oneOf(connector.GDCOM) && (typeof GDComSocial === "undefined" || !GDComSocial.isAppropriate())
        || connector.platform.oneOf(connector.CLEVERAPPS) && location.href.includes("scramble.cleverappssg.com")) {
        return NoSocial;
    }

    if (typeof SelectSocial !== "undefined") {
        if (WebViewFacebook.isAvailable()
            && (typeof AndroidSocial !== "undefined" && AndroidSocial.isAvailable() || typeof AppleSocial !== "undefined" && AppleSocial.isAvailable())) {
            return SelectSocial;
        }
    }

    const socials = {
        instant: typeof InstantSocial !== "undefined" && InstantSocial,
        ok: typeof OKSocial !== "undefined" && OKSocial,
        okbridge: typeof OKBridgeSocial !== "undefined" && OKBridgeSocial,
        mm: typeof MyMailRuSocial !== "undefined" && MyMailRuSocial,
        vk: typeof VKSocial !== "undefined" && VKSocial,
        sp_mbga: typeof SPMobageSocial !== "undefined" && SPMobageSocial,
        mbga: typeof MobageSocial !== "undefined" && MobageSocial,
        draugiem: typeof DraugiemSocial !== "undefined" && DraugiemSocial,
        fotostrana: typeof FotoStranaSocial !== "undefined" && FotoStranaSocial,
        cleverapps: typeof XsollaSocial !== "undefined" && XsollaSocial,
        yandex: typeof YandexSocial !== "undefined" && YandexSocial,
        macos: typeof AppleSocial !== "undefined" && AppleSocial,
        gpg: typeof AndroidSocial !== "undefined" && AndroidSocial,
        amazon: typeof WebViewFacebook !== "undefined" && WebViewFacebook,
        onestore: typeof OneStoreSocial !== "undefined" && OneStoreSocial,
        ios: typeof AppleSocial !== "undefined" && AppleSocial,
        samsung: typeof SamsungSocial !== "undefined" && SamsungSocial,
        mygames: typeof MygamesSocial !== "undefined" && MygamesSocial,
        microsoft: typeof MicrosoftFacebook !== "undefined" && MicrosoftFacebook,
        msstart: typeof MSStartSocial !== "undefined" && MSStartSocial,
        pwa: typeof XsollaSocial !== "undefined" && XsollaSocial,
        msix: typeof XsollaSocial !== "undefined" && XsollaSocial,
        plng: typeof PlingaSocial !== "undefined" && PlingaSocial,
        kongregate: typeof KongregateSocial !== "undefined" && KongregateSocial,
        crazy: typeof CrazySocial !== "undefined" && CrazySocial,
        wechat: typeof WechatSocial !== "undefined" && WechatSocial,
        android: typeof AndroidSocial !== "undefined" && AndroidSocial,
        discord: typeof DiscordSocial !== "undefined" && DiscordSocial,
        telegram: typeof TelegramSocial !== "undefined" && TelegramSocial,
        mspwa: typeof MSPwaSocial !== "undefined" && MSPwaSocial,
        test: typeof TestSocial !== "undefined" && TestSocial,
        gdcom: typeof GDComSocial !== "undefined" && GDComSocial.isAppropriate() && GDComSocial,
        reddit: typeof RedditSocial !== "undefined" && RedditSocial,
        epicgames: typeof EpicGamesSocial !== "undefined" && EpicGamesSocial,
        tiktok: typeof TikTokSocial !== "undefined" && TikTokSocial,
        arkadium: typeof ArkadiumSocial !== "undefined" && ArkadiumSocial,
        pogo: typeof PogoSocial !== "undefined" && PogoSocial,
        labsystech: typeof LabSysTechSocial !== "undefined" && LabSysTechSocial
    };

    let source = connector.info.source;
    if (connector.platform.oneOf(connector.OKBRIDGE)) {
        source = "okbridge";
    }
    return socials[source] || NoSocial;
};
